<template>
  <div class="refer">
    <div class="main">
      <div class="list" v-for="(item, index) in currentPageData" :key="index">
        <p>{{ index + 1 }}.</p>
        <p>
          {{ item.text
          }}<span style="color: #27ca8d"> [PMID{{ item.pmid }}] </span>
        </p>
      </div>
      <div>
        <div
          v-if="currentPageData.length == productList.length"
          class="openStyle"
          @click="close()"
        >
          收起 <i class="iconfont icon-up_medium"></i>
        </div>
        <div
          v-if="currentPageData.length < productList.length"
          class="openStyle"
          @click="openList()"
        >
          展开 <i class="iconfont icon-down_medium"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
    },
  },
  data() {
    return {
      productList: [], //所有数据
      totalPage: 1, // 统共页数，默认为1
      currentPage: 1, //当前页数 ，默认为1
      pageSize: 4, // 每页显示数量
      currentPageData: [], //当前页显示内容
    };
  },
  watch: {
    dataList: function (val) {
      this.productList = val;
      this.openData();
    },
  },
  mounted() {},
  methods: {
    close() {
      console.log(this.currentPage);
      this.currentPage = 1;

      this.currentPageData = this.currentPageData.slice(0, 4);
    },
    openList() {
      if (this.currentPage == this.totalPage) return;
      this.currentPage++;
      this.openData();
    },
    /**处理展开收起数据 */
    openData() {
      this.totalPage = Math.ceil(this.productList.length / this.pageSize);
      console.log(this.totalPage);
      // 计算得0时设置为1
      this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
      let begin = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      let objList = [
        ...this.currentPageData,
        ...this.productList.slice(begin, end),
      ];
      this.currentPageData = objList.map((item)=>{
        return{
          ...item,
          text:item.referencesEssay.replace("[PMID:"+item.pmid+"]","")
        }
      })
      console.log(this.currentPageData,'222222')
      // for (let i = 0; i < this.currentPageData.length; i++) {
      //   let splitFirst = this.currentPageData[i].referencesEssay.replace("[PMID:"+this.currentPageData[i].pmid+"]","");
      //   console.log(splitFirst, "bbbbbb");
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.refer {
  .openStyle {
    text-align: center;
    height: 40px;
    font-size: 12px;
    font-weight: 400;
    color: #4b84ff;
    line-height: 40px;
    border-top: 1px solid #e3e5e8;
    margin-top: 20px;
    i {
      color: #4b84ff;
      font-size: 12px;
    }
  }
  .main {
    padding: 0 24px 10px;
    .list {
      display: flex;
      p {
        font-size: 13px;
        font-family: @family;
        font-weight: 400;
        color: #5f697d;
        line-height: 24px;
        word-break: break-all;
        text-align: justify;
        text-justify: newspaper;
        &:first-child {
          margin-right: 8px;
          min-width: 24px;
        }
      }
    }
  }
}
</style>
